import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import DefaultEins from "./DefaultEins";
import ReportIdView from "./ReportId";
import ComparisonColumns from "./ComparisonColumns";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getPHReportSettings, savePHReportSettings, GetEins } from '../../../../../../store/actions';
import IconSettingClass from '../../../../../../components/settingsIcon';
import capitalize from 'lodash/capitalize';

const PHReportSettingsView = props => {

    const [comparisonColumns, setComparisonColumns] = useState([]);
    const [payrollReportId, setPayrollReportId] = useState("");
    const [coordinatorsReportId, setCoordinatorsReportId] = useState("");
    const [EinList, setEINList] = useState([]);
    const [DefaultEin, setDefaultEin] = useState("");
    const { companyId, _id } = props.ClientDataReducer;

    useEffect(() => {
        const getReportSettings = async () => {
            await props.getPHReportSettings(companyId);
            updatePHRS();
        }
        getReportSettings()
    }, [EinList]);

    useEffect(() => {
        const getEINList = async () => {
            await props.GetEins(_id);
            setEINList([...(props.EINS?.records || [])]);
            setDefaultEin(props.EINS?.defaultSelected);
        };
        getEINList();
    }, [payrollReportId]);

    async function savePHRS(payload) {
        await props.savePHReportSettings(payload);
        // updatePHRS()
    };

    function updatePHRS() {
        const { PHRS } = props;
        const COMP_COLS = PHRS?.comparisonColumns.map(cc => {
            cc.label = cc.key.split("_").map(capitalize).join(" ");
            return cc;
        })
        setComparisonColumns(COMP_COLS);
        setPayrollReportId(PHRS?.payrollReportID);
        setCoordinatorsReportId(PHRS?.coordinatorReportID);
    }

    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<IconSettingClass />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className="reportTitle">PATIENT HOURS REPORT</Typography>
            </AccordionSummary>

            <AccordionDetails>
                <div className="reportListAccording mar-0">
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Report id</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ReportIdView
                                payrollReportID={payrollReportId}
                                coordinatorReportID={coordinatorsReportId}
                                companyId={companyId}
                                onSave={savePHRS}></ReportIdView>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography className="titleAccording">Default EIN</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <DefaultEins
                                einList={EinList}
                                companyId={companyId}
                                defaultEin={DefaultEin}
                                onSave={savePHRS}></DefaultEins>
                        </AccordionDetails>
                    </Accordion>


                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography className="titleAccording">Comparison columns</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ComparisonColumns
                                companyId={companyId}
                                comparisonColumns={comparisonColumns}
                                onSave={savePHRS}
                            ></ComparisonColumns>
                        </AccordionDetails>
                    </Accordion>
                </div>


            </AccordionDetails>
        </Accordion>
    )
};

const mapStateToProps = ({ UserReducer, PatientReducer, ClientDataReducer }) => {
    const { PHRS, EINS } = PatientReducer;
    return { UserReducer, PHRS, EINS, ClientDataReducer };
};

export default connect(mapStateToProps, {
    getPHReportSettings,
    savePHReportSettings,
    GetEins,
})(PHReportSettingsView);
